import { Button, Popover, StatusIndicator } from '@awsui/components-react';
import React from 'react';
import { formatChatHistoryToString } from './utils';

const copyToClipboard = (content) => {
  navigator.clipboard.writeText(content).then(
    () => {
      return true;
    },
    () => {
      return false;
    },
  );
};

const handleCopyClick = (contentToCopy) => {
  if (contentToCopy) {
    copyToClipboard(contentToCopy);
  }
};

// eslint-disable-next-line
export const CopyButton = ({ data, disabled }) => {
  // Format the chat history array into a string
  const formattedChatHistory = formatChatHistoryToString(data);

  return (
    <Popover
      size="small"
      position="bottom"
      triggerType="custom"
      dismissButton={false}
      content={<StatusIndicator type="success">Copied</StatusIndicator>}
    >
      <Button
        disabled={disabled}
        ariaLabel="copy"
        iconName="copy"
        onClick={() => handleCopyClick(formattedChatHistory)}
      >
        Copy
      </Button>
    </Popover>
  );
};
